import React, { useState } from 'react';
import axios from './api';

function AddWallet({ fetchWallets }) {
  const [wallet, setWallet] = useState('');
  const [amount, setAmount] = useState('');

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/add-wallet/', { wallet, amount });
      setWallet('');
      setAmount('');
      fetchWallets(); // refresh dashboard
    } catch (err) {
      console.error(err.response?.data || 'Error adding wallet');
    }
  };

  return (
    <form onSubmit={handleAdd}>
      <input placeholder="Wallet" value={wallet} onChange={e => setWallet(e.target.value)} />
      <input placeholder="Amount" value={amount} onChange={e => setAmount(e.target.value)} />
      <button type="submit">Add Wallet</button>
    </form>
  );
}

export default AddWallet;
